/* eslint-disable indent */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable eqeqeq */
/* eslint-disable no-underscore-dangle */
import React, { useContext, useMemo, useState, useEffect } from 'react';
import { List, DataColumn, ListHeader } from 'components/lists';
import { Context as AuthContext } from 'contexts/auth';
import { Context as CompanyContext } from 'contexts/company';
import { Context as AlertContext } from 'contexts/alert';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Config } from 'configs';
import { Input } from 'components/formInputs/input';
import { useFind } from 'hooks';
import { TextboxWrapper } from 'components/formInputs/wrappers/textboxWrapper';
import { DropdownWrapper } from 'components/formInputs/wrappers/dropdownWrapper';
import { getTranslatedData } from 'locales';

export const ProductsAddNewPricing = ({ itemData, productVariations }) => {
  const { state: auth } = useContext(AuthContext);
  const { editById } = useContext(CompanyContext);
  const { alertController } = useContext(AlertContext);

  const [listPrice, setListPrice] = useState(0);
  const [basePrice, setBasePrice] = useState(0);
  const [vatSize, setVatSize] = useState(0);
  const [vatPrice, setVatPrice] = useState(0);

  const [deliveryPackagingItems, setDeliveryPackagingItems] = useState([]);
  const [takeawayPackagingItems, setTakeawayPackagingItems] = useState([]);
  const [dineinPackagingItems, setDineinPackagingItems] = useState([]);

  const calculateVatPrice = (listPriceVal, vatSizeVal) => {
    if (!listPriceVal || !vatSizeVal) {
      return 0;
    }

    return (
      Math.round(
        ((listPriceVal / (1 + vatSizeVal / 100) - listPriceVal) * -1 + Number.EPSILON) * 100,
      ) / 100
    );
  };

  const calculateBasePrice = (listPriceVal, vatSizeVal) => {
    return listPrice - calculateVatPrice(listPriceVal, vatSizeVal);
  };

  useEffect(() => {
    if (itemData) {
      setListPrice(itemData.prime_cost || 0);
      setVatSize(itemData.vat_size || 0);
      setBasePrice(calculateBasePrice(itemData.prime_cost, itemData.vat_size));
      setVatPrice(calculateVatPrice(itemData.prime_cost, itemData.vat_size));
    }
  }, [itemData]);

  useEffect(() => {
    setBasePrice(calculateBasePrice(listPrice, vatSize));
    setVatPrice(calculateVatPrice(listPrice, vatSize));
  }, [vatSize, listPrice]);

  /*
  const getDiscountsResquestData = {
    secretKey: auth.token,
    collectionName: Config.DATA.COLLECTIONS.DISCOUNTS,
    filter: `{ enabled: true, company: ObjectId("${
      auth.company?.company
    }"), type: 'Static', $or: [{all_products: true}, { products: { $in : [ObjectId("${
      itemData?._id
    }")]}}, { product_categories: { $in: [${itemData?.categories
      ?.map((c) => `ObjectId("${c}")`)
      .join(',')}] }  }] }`,
    cultureCode: Config.DEFAULTS.LANGUAGE,
    includeCollectionNames: true,
  };

  const [, discounts] = useFind(getDiscountsResquestData); */

  const schema = yup.object().shape({
    _id: yup.string().default(itemData?._id),
    prime_cost: yup
      .number()
      .min(0, 'Must be greater than 0')
      .nullable(false)
      .transform((_, val) => (val == Number(val) && val !== '' ? Number(val) : -1))
      .required('Please enter base price.')
      .default(itemData?.prime_cost),
    package_cost: yup
      .number()
      .min(0, 'Must be greater than 0')
      .nullable(true)
      .transform((_, val) => (val == Number(val) && val !== '' ? Number(val) : 0))
      .default(itemData?.package_cost),
    package_cost_delivery: yup
      .number()
      .min(0, 'Must be greater than 0')
      .nullable(true)
      .transform((_, val) => (val == Number(val) && val !== '' ? Number(val) : 0))
      .default(itemData?.package_cost_delivery),
    vat_size: yup
      .number()
      .min(0, 'Must be greater or equal to 0')
      .max(100, 'Must be less or equal to 100')
      .nullable(true)
      .transform((_, val) => (val == Number(val) && val !== '' ? Number(val) : 0))
      // .required('Please enter list price.')
      .default(itemData?.vat_size),
    delivery_package_variation_id: yup.string().default(itemData?.delivery_package_variation_id),
    delivery_package_option_id: yup.string().default(itemData?.delivery_package_option_id),
    takeaway_package_variation_id: yup.string().default(itemData?.takeaway_package_variation_id),
    takeaway_package_option_id: yup.string().default(itemData?.takeaway_package_option_id),
    dinein_package_variation_id: yup.string().default(itemData?.dinein_package_variation_id),
    dinein_package_option_id: yup.string().default(itemData?.dinein_package_option_id),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      return schema.default();
    }, [schema]),
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (productVariations) {
      if (itemData?.delivery_package_variation_id) {
        const selectedVariation = productVariations.find(
          (x) => x._id === itemData?.delivery_package_variation_id,
        );

        setDeliveryPackagingItems(selectedVariation?.items || []);
      } else {
        setDeliveryPackagingItems([]);
      }

      if (itemData?.takeaway_package_variation_id) {
        const selectedVariation = productVariations.find(
          (x) => x._id === itemData?.takeaway_package_variation_id,
        );

        setTakeawayPackagingItems(selectedVariation?.items || []);
      } else {
        setTakeawayPackagingItems([]);
      }

      if (itemData?.dinein_package_variation_id) {
        const selectedVariation = productVariations.find(
          (x) => x._id === itemData?.dinein_package_variation_id,
        );

        setDineinPackagingItems(selectedVariation?.items || []);
      } else {
        setDineinPackagingItems([]);
      }
    }

    if (itemData) {
      reset(itemData);
    }
  }, [itemData, productVariations]);

  const isRKeeper = !!itemData?.rkeeper_dish_code;

  const onSubmit = async (data) => {
    let submitData;

    if (isRKeeper) {
      submitData = {
        package_cost: data.package_cost,
        package_cost_delivery: data.package_cost_delivery,
      };
    } else {
      submitData = {
        prime_cost: data.prime_cost,
        package_cost: data.package_cost,
        package_cost_delivery: data.package_cost_delivery,
      };
    }

    submitData.delivery_package_variation_id = data.delivery_package_variation_id || '';
    submitData.delivery_package_option_id = data.delivery_package_option_id || '';
    submitData.takeaway_package_variation_id = data.takeaway_package_variation_id || '';
    submitData.takeaway_package_option_id = data.takeaway_package_option_id || '';
    submitData.dinein_package_variation_id = data.dinein_package_variation_id || '';
    submitData.dinein_package_option_id = data.dinein_package_option_id || '';

    await editById(
      {
        collectionName: Config.DATA.COLLECTIONS.PRODUCTS,
        id: itemData?._id,
        updateClause: { $set: { ...submitData } },
        token: auth.token,
        resourceV2: 'AdminProduct',
        updateTypeV2: 'Pricing',
        updateDataV2: submitData,
        companyIdForV2: auth.company?.company,
      },
      () => {
        alertController.show('Price for product updated successfully.');
      },
    );
  };
  const onError = (data) => console.log(data);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit, onError)} action="#" method="POST">
        <div className="shadow sm:rounded-md sm:overflow-hidden">
          <div className="bg-white py-6 px-4 space-y-6 sm:p-6">
            <div>
              <h3 className="text-lg leading-6 font-medium text-gray-900">Pricing</h3>
              <p className="mt-1 text-sm text-gray-500">Your product pricing</p>
            </div>

            <div className="grid grid-cols-6 gap-6">
              <div className="col-span-6 sm:col-span-3">
                <label htmlFor="prime_cost" className="block text-sm font-medium text-gray-700">
                  Product price*
                </label>
                <div className="mt-1 relative rounded-md shadow-sm">
                  <Input
                    {...register('prime_cost')}
                    className={`focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md ${
                      isRKeeper
                        ? 'disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-500'
                        : ''
                    }`}
                    name="prime_cost"
                    id="prime_cost"
                    type="text"
                    // renderAsCurrencyInput
                    errorMessage={errors?.prime_cost}
                    disabled={isRKeeper}
                    onChange={(e) => {
                      setListPrice(e.target.value);
                    }}
                  />
                </div>
                {errors?.prime_cost && (
                  <p className="mt-2 text-sm text-red-600" id="email-error">
                    {errors?.prime_cost.message}
                  </p>
                )}
              </div>
              <div className="hidden sm:block sm:col-span-3" />

              <TextboxWrapper
                register={register}
                name="package_cost"
                title="Packaging price"
                subtitle="Packaging price used for takeout and delivery"
                error={errors?.package_cost}
                responsiveClassName="col-span-6 sm:col-span-3"
              />

              <TextboxWrapper
                register={register}
                name="package_cost_delivery"
                title="Packaging price (delivery)"
                subtitle="Override packaging price for delivery only"
                error={errors?.package_cost_delivery}
                responsiveClassName="col-span-6 sm:col-span-3"
              />

              <div className="col-span-6 w-full h-[1px] bg-gray-100 mt-2 mb-2" />

              <div className="col-span-6">
                <div className="mb-6">
                  <div className="text-base font-medium text-gray-900">
                    Packaging as variations (experimental)
                  </div>
                  <p className="text-sm text-gray-500 mt-1">
                    Variations will be attached as a packaging item
                  </p>
                </div>
              </div>

              <DropdownWrapper
                register={register}
                name="dinein_package_variation_id"
                title="Dine-in packaging variation"
                options={
                  productVariations && productVariations.length > 0
                    ? [
                        { label: '-', value: '' },
                        ...productVariations.map((x) => ({
                          label: getTranslatedData(x.name),
                          value: x._id,
                        })),
                      ]
                    : [{ label: '-', value: '' }]
                }
                error={errors?.dinein_package_variation_id}
                responsiveClassName="col-span-6 sm:col-span-3"
                onChange={(e) => {
                  const newId = e.target.value;

                  setValue('dinein_package_option_id', '');

                  if (newId) {
                    const selectedVariation = productVariations.find((x) => x._id === newId);

                    setDineinPackagingItems(selectedVariation?.items || []);
                  } else {
                    setDineinPackagingItems([]);
                  }
                }}
              />
              <DropdownWrapper
                register={register}
                name="dinein_package_option_id"
                title="Dine-in packaging item"
                options={
                  dineinPackagingItems && dineinPackagingItems.length > 0
                    ? [
                        { label: '-', value: '' },
                        ...dineinPackagingItems.map((x) => ({
                          label: getTranslatedData(x.name),
                          value: x.id,
                        })),
                      ]
                    : [{ label: '-', value: '' }]
                }
                error={errors?.dinein_package_option_id}
                responsiveClassName="col-span-6 sm:col-span-3"
              />

              <DropdownWrapper
                register={register}
                name="takeaway_package_variation_id"
                title="Takeaway packaging variation"
                options={
                  productVariations && productVariations.length > 0
                    ? [
                        { label: '-', value: '' },
                        ...productVariations.map((x) => ({
                          label: getTranslatedData(x.name),
                          value: x._id,
                        })),
                      ]
                    : [{ label: '-', value: '' }]
                }
                error={errors?.takeaway_package_variation_id}
                responsiveClassName="col-span-6 sm:col-span-3"
                onChange={(e) => {
                  const newId = e.target.value;

                  setValue('takeaway_package_option_id', '');

                  if (newId) {
                    const selectedVariation = productVariations.find((x) => x._id === newId);

                    setTakeawayPackagingItems(selectedVariation?.items || []);
                  } else {
                    setTakeawayPackagingItems([]);
                  }
                }}
              />
              <DropdownWrapper
                register={register}
                name="takeaway_package_option_id"
                title="Takeaway packaging item"
                options={
                  takeawayPackagingItems && takeawayPackagingItems.length > 0
                    ? [
                        { label: '-', value: '' },
                        ...takeawayPackagingItems.map((x) => ({
                          label: getTranslatedData(x.name),
                          value: x.id,
                        })),
                      ]
                    : [{ label: '-', value: '' }]
                }
                error={errors?.takeaway_package_option_id}
                responsiveClassName="col-span-6 sm:col-span-3"
              />

              <DropdownWrapper
                register={register}
                name="delivery_package_variation_id"
                title="Delivery packaging variation"
                options={
                  productVariations && productVariations.length > 0
                    ? [
                        { label: '-', value: '' },
                        ...productVariations.map((x) => ({
                          label: getTranslatedData(x.name),
                          value: x._id,
                        })),
                      ]
                    : [{ label: '-', value: '' }]
                }
                error={errors?.delivery_package_variation_id}
                responsiveClassName="col-span-6 sm:col-span-3"
                onChange={(e) => {
                  const newId = e.target.value;

                  setValue('delivery_package_option_id', '');

                  if (newId) {
                    const selectedVariation = productVariations.find((x) => x._id === newId);

                    setDeliveryPackagingItems(selectedVariation?.items || []);
                  } else {
                    setDeliveryPackagingItems([]);
                  }
                }}
              />
              <DropdownWrapper
                register={register}
                name="delivery_package_option_id"
                title="Delivery packaging item"
                options={
                  deliveryPackagingItems && deliveryPackagingItems.length > 0
                    ? [
                        { label: '-', value: '' },
                        ...deliveryPackagingItems.map((x) => ({
                          label: getTranslatedData(x.name),
                          value: x.id,
                        })),
                      ]
                    : [{ label: '-', value: '' }]
                }
                error={errors?.delivery_package_option_id}
                responsiveClassName="col-span-6 sm:col-span-3"
              />

              {/* <div className="col-span-6 sm:col-span-3">
                <label htmlFor="price" className="block text-sm font-medium text-gray-700">
                  VAT size (%)
                </label>
                <div className="mt-1 relative rounded-md shadow-sm">
                  <Input
                    {...register('vat_size')}
                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-500"
                    name="vat_size"
                    id="vat_size"
                    type="text"
                    errorMessage={errors?.vat_size}
                    disabled={isRKeeper}
                    onChange={(e) => {
                      setVatSize(e.target.value);
                    }}
                  />
                </div>
                {errors?.vat_size && (
                  <p className="mt-2 text-sm text-red-600" id="email-error">
                    {errors?.vat_size.message}
                  </p>
                )}
                <p className="block text-sm text-gray-500 mt-2">
                  Base price: {basePrice.toFixed(2)}
                </p>
                <p className="block text-sm text-gray-500 mt-2">
                  VAT price: {vatPrice.toFixed(2)}
                </p>
              </div> */}
            </div>
          </div>

          <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
            <button
              type="submit"
              className="bg-indigo-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Save
            </button>
          </div>
        </div>
      </form>
      {/* discounts && discounts.length > 0 && (
        <div className="w-full">
          <ListHeader
            title="Pricing"
            description="Enabled pricing set either for this product or for one of product category"
          />
          <List source={discounts}>
            <DataColumn
              name="When"
              dbColumnName="from"
              render={(item) => renderTime(item)}
              headerClass="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
              dataCellClass="whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell"
            />

            <DataColumn
              name="Name"
              dbColumnName="name"
              headerClass="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
              dataCellClass="whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell"
              stackedColumns={[
                { name: 'Type', render: (item) => renderPricingModelType(item), class: 'mt-1 truncate text-gray-400 sm:hidden' },
              ]}
            />
            <DataColumn
              name="Type"
              dbColumnName="type"
              render={(item) => renderPricingModelType(item)}
              headerClass="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
              dataCellClass="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell"
            />
          </List>
        </div>
      ) */}
    </>
  );
};
